import React, {useEffect} from 'react';
import MainLayoutIgniter from "../common/mainLayout";
import {Heading2, Heading3, Text4} from "../../../libs/uiKit/globalStyledComponents";
import {
    StyledAgreementNumber,
    StyledContractHeader, StyledContractRegistrationForm,
    StyledContractWrapper,
    StyledEventsButtons,
    StyledHeaderInformation,
    StyledHeaderWrapper,
    StyledImportantNumber,
    StyledInformationItem,
    StyledTotalInformation,
    StyledTotalInformationItem
} from "../contract/ui/styles";
import {FormProvider, useForm} from "react-hook-form";
import {ContractForm} from "../contract";
import Button from "../../../libs/uiKit/button";
import FlyButtons from "../../../libs/uiKit/flyButtons";
import LoadingString from "../../../libs/uiKit/loadingString";
import Status from "../../../libs/uiKit/status";
import {useQuery} from "@apollo/react-hooks";
import {
    LoadContractQuery,
    LoadContractQueryVariables, LoadCrossContractQuery,
    LoadFlatContractQuery,
    LoadFlatContractQueryVariables
} from "../../../libs/api/graphqlTypes";
import {LOAD_CONTRACT, LOAD_CROSS_CONTRACT, LOAD_FLAT_CONTRACT} from "../../../libs/api/queries";
import useNotification from "../../widgets/notifier/ui/hooks/useNitification";
import {AgreementId} from "../createAgreement/ui/context";
import {useNavigate, useParams} from "react-router-dom";
import {stringToMoney} from "../../../libs/uiKit/utils";
import ContragentIgniter from "../createAgreement/widgets/contragent";
import {formatAgreementDataToFormData, formatPersonDataToDataForm} from "../createAgreement/ds/repositories/commands";
import FlatStep from "../createAgreement/pages/flat";
import {useGlobalContext} from "../../../apps/main/ui/GlobalContext";
import {IForm} from "../../../libs/uiKit/fieldsBuilder/types";
import dayjs from "dayjs";
import {FieldsBuilder} from "../../../libs/uiKit/fieldsBuilder";

type InformationItem = { title: string; description: React.ReactNode };


const CrossContractPage = () => {

    const formHook = useForm({ mode: 'onBlur' });

    const { setNotification } = useNotification();
    const navigate = useNavigate();

    const { id } = useParams<{ id?: string }>();
    const contractId: AgreementId = Number.isNaN(Number(id)) ? null : Number(id);

    const {
        routes: { invoiceById },
    } = useGlobalContext();

    const { data: dataContract, loading: loadingContract } = useQuery<LoadCrossContractQuery, LoadContractQueryVariables>(LOAD_CROSS_CONTRACT, {
        variables: { id: contractId },
        onError: error => setNotification({ text: error, type: 'error' }),
        fetchPolicy: 'network-only',
    });

    const {
        status,
        added,
        number,
        agreement,
        crossDetails
    } = dataContract?.loadAgreement || {};


    useEffect(() => {
        if(!dataContract) return;
        const formData = formatAgreementDataToFormData(dataContract);
        Object.entries(formData).forEach(([key, value]) => {
            if (value === null || value === undefined) return;
            formHook.setValue(key, value);
        });
    }, [dataContract]);

    const isPayed = agreement?.is_payed || false;

    const policyholder = formatPersonDataToDataForm(agreement?.policyholder || {});

    const goToInvoiceHandler = () => {
        navigate(invoiceById(String(contractId)));
    };

    const informationItems: InformationItem[] = [
        {
            title: 'Номер договора',
            description: (
                <StyledAgreementNumber>
                    <Text4>{number}</Text4>
                </StyledAgreementNumber>
            ),
        },
        {
            title: 'Статус подписания',
            description: (
                <LoadingString isLoading={loadingContract}>
                    <Status status={status?.label} color={status?.color}/>
                </LoadingString>
            ),
        },
        {
            title: 'Статус оплаты',
            description: (
                <LoadingString isLoading={loadingContract}>
                    {isPayed ? <Status status='Оплачен' color='#397e2d'/> : <Status status='Не оплачен' color='#d23630'/>}
                </LoadingString>
            ),
        },
        {
            title: 'Создан',
            description: (
                <LoadingString isLoading={loadingContract}>
                    <Text4>{added}</Text4>
                </LoadingString>
            ),
        }
    ];

    const totalInformationItems: InformationItem[] = [
        {
            title: 'Итого',
            description: (
                <LoadingString isLoading={loadingContract}>
                    <Text4>{stringToMoney(agreement?.premium_sum)} RUB</Text4>
                </LoadingString>
            ),
        }
    ];


    const formPart1: IForm = {
        formHook,
        fields: [
            {
                field: {
                    fieldType: 'input',
                    fieldName: 'contractNumber',
                    isDisabled: true,
                    placeholder: 'Номер договора',
                    value: agreement?.agreement_no || "",
                    grid: 6,
                },
            },
            {
                field: {
                    fieldType: 'input',
                    fieldName: 'borrower',
                    isDisabled: true,
                    placeholder: 'Страхователь',
                    value: agreement?.policyholder?.fio  || "",
                    grid: 6,
                },
            },
            {
                field: {
                    fieldType: 'input',
                    fieldName: 'dateSign',
                    isDisabled: true,
                    placeholder: 'Договор подписан',
                    value: agreement?.date_sign  || "",
                    grid: 4,
                },
            },

            {
                field: {
                    fieldType: 'input',
                    fieldName: 'dateBeg',
                    isDisabled: true,
                    placeholder: 'Дата начала действия договора',
                    value: agreement?.date_begin || "",
                    grid: 4
                },
            },
            {
                field: {
                    fieldType: 'input',
                    fieldName: 'dateEnd',
                    isDisabled: true,
                    placeholder: 'Дата конца действия договора',
                    value: agreement?.date_end || "",
                    grid: 4
                },
            },
        ],
    }

    const crossInfoForm: IForm = {
        formHook,
        hotReload: true,
        fields: [
            // адрес объекта, страховая сумма, внутренняя отделка, гражданская ответственность, движимое имущество
            {
                field: {
                    fieldType: 'input',
                    fieldName: `crossAddress`,
                    placeholder: 'Адрес объекта страхования',
                    value: crossDetails?.address || "",
                    isDisabled: true,
                    grid: 6,
                },
            },
            {
                field: {
                    fieldType: 'input',
                    fieldName: `crossLimitSum`,
                    placeholder: 'Страховая сумма',
                    value: crossDetails?.sum ? stringToMoney(crossDetails?.sum) : "",
                    isDisabled: true,
                    grid: 6,
                },
            },
            {
                field: {
                    fieldType: 'input',
                    fieldName: `crossInterior`,
                    placeholder: 'Внутренняя отделка',
                    value: crossDetails?.interior ? stringToMoney(crossDetails?.interior) : "",
                    isDisabled: true,
                    grid: 4,
                },
            },
            {
                field: {
                    fieldType: 'input',
                    fieldName: `crossResponsibility`,
                    placeholder: 'Гражданская ответственность',
                    value: crossDetails?.responsibility ? stringToMoney(crossDetails?.responsibility) : "",
                    isDisabled: true,
                    grid: 4,
                },
            },
            {
                field: {
                    fieldType: 'input',
                    fieldName: `crossProperty`,
                    placeholder: 'Движимое имущество',
                    value: crossDetails?.property ? stringToMoney(crossDetails?.property) : "",
                    isDisabled: true,
                    grid: 4,
                },
            },
        ],
    }

    return (
        <MainLayoutIgniter>
            <Heading2>Договор страхования</Heading2>
            <StyledContractWrapper>
                <FormProvider {...formHook}>
                    <StyledHeaderWrapper>
                        <StyledContractHeader>
                            <Heading3>Общие сведения</Heading3>
                            <StyledEventsButtons>
                                <FlyButtons isWhiteBackground={true}>
                                    <Button appearance='transparent' onClick={goToInvoiceHandler}>
                                        Документы и оплата
                                    </Button>
                                </FlyButtons>
                            </StyledEventsButtons>
                        </StyledContractHeader>
                        <StyledHeaderInformation>
                            {informationItems.map(({ title, description }, index) => (
                                <StyledInformationItem key={`info-item-${index}`}>
                                    <Text4>{title}</Text4>
                                    {description}
                                </StyledInformationItem>
                            ))}
                            <StyledTotalInformation>
                                {totalInformationItems.map(({ title, description }, index) => (
                                    <StyledTotalInformationItem key={`info-item-${index}`}>
                                        <Text4>{title}</Text4>
                                        {description}
                                    </StyledTotalInformationItem>
                                ))}
                            </StyledTotalInformation>
                        </StyledHeaderInformation>
                    </StyledHeaderWrapper>
                    <StyledContractRegistrationForm>
                        <br/>
                        <br/>
                        <FieldsBuilder {...formPart1} />
                        <Heading3>Страхователь</Heading3>
                        <ContragentIgniter
                            isShowShare={false}
                            isShowSearchByIsn={false}
                            number={0}
                            arrayName='contragent'
                            searchSuccessCallback={(contragent, number) => {}}
                            contragentDisabled={true}
                            postfix='страхователя'
                            defaultValues={policyholder}
                            flatMode={true}
                        />
                        <Heading3>Объект страхования</Heading3>
                        <FieldsBuilder {...crossInfoForm} />
                    </StyledContractRegistrationForm>

                </FormProvider>
            </StyledContractWrapper>
        </MainLayoutIgniter>
    );
}

export default CrossContractPage;